/**
 * Ownership + copyright line (the admin's "About"). Rendered as the footer of
 * every top-level screen. "Watch Keeper" is a registered Canadian trademark of
 * J.W. Sadler Ltd.: mark the FIRST branded mention per screen with ® and leave
 * later mentions bare. Never mark code identifiers (`watchkeeper` slugs etc.).
 */
export const TRADEMARK_NOTICE =
  'Watch Keeper® is a registered trademark of J.W. Sadler Ltd., registered in Canada. © 2026 J.W. Sadler Ltd. All rights reserved.';

export function TrademarkNotice({ className = '' }: { className?: string }) {
  return (
    <footer className={`text-center text-xs text-gray-400 ${className}`}>
      {TRADEMARK_NOTICE}
    </footer>
  );
}
